import { render, staticRenderFns } from "./RecommendDialogV2.vue?vue&type=template&id=7b805ab4&scoped=true&"
import script from "./RecommendDialogV2.vue?vue&type=script&lang=js&"
export * from "./RecommendDialogV2.vue?vue&type=script&lang=js&"
import style0 from "../../../company/statistics/css/common.css?vue&type=style&index=0&id=7b805ab4&scoped=true&lang=css&"
import style1 from "./RecommendDialogV2.vue?vue&type=style&index=1&lang=css&"
import style2 from "./RecommendDialogV2.vue?vue&type=style&index=2&id=7b805ab4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b805ab4",
  null
  
)

export default component.exports